<template>
    <div>
        <x-header :left-options="{backText: ''}" >{{$t('account.credit.title')}}</x-header>
        <group>
            <popup-picker :title="$t('account.credit.receiveType')" :data="[[$t('account.credit.wechat'),$t('account.credit.transfer')]]" 
            v-model="receiptType" value-text-align="right"></popup-picker>
            <x-input :title="$t('account.credit.receiptName')" text-align="right" v-model="receiptName" required></x-input>
            <x-input :title="$t('account.credit.receiptNumber')" :placeholder="$t('account.credit.enterNumber')" text-align="right" v-model="receiptAccount" required></x-input>
        </group>
        <div style="padding: 20px 25px 0px 25px; color: red">{{$t('account.credit.beforeUploadConfirm')}}</div>
        <div style="padding: 20px 30px 0px 30px">
            <x-button v-if="receiptAccount != '' && receiptName != ''" type="primary" style="background-color: #5890DC; " @click.native="editReceipt">{{$t('account.credit.upload')}}</x-button>
            <x-button v-else type="primary" style="background-color: #5890DC; " @click.native="showAlert">{{$t('account.credit.upload')}}</x-button>
        </div>
        <div v-transfer-dom>
            <alert v-model="success" :title="$t('account.credit.remind')" :button-text="$t('general.confirm')" @click.native="$router.push('/account/credit')">{{$t('account.credit.successAlert')}}</alert>
            <alert v-model="alert" :title="$t('account.credit.remind')" :button-text="$t('general.confirm')" >{{$t('account.credit.failAlert')}}</alert>
        </div>
    </div>
</template>
，
<script>
import { XHeader, Group, PopupPicker, XInput, Flexbox, FlexboxItem, TransferDomDirective as TransferDom, Alert } from 'vux'
export default {
    name: 'EditUser',
    directives: {
        TransferDom
    },
    components: {
        XHeader, 
        Group, 
        PopupPicker, 
        XInput,
        Flexbox, 
        FlexboxItem,
        Alert
    },
    data() {
        return{
            receiptType: ['微信'],
            receiptName: '',
            receiptAccount: '',
            success: false,
            alert: false,
        }
    },
    methods: {
        editReceipt() {
            this.$store.dispatch('Account/editReceipt', {
                receiptType: this.receiptTypeCategorise(),
                receiptName: this.receiptName,
                receiptAccount: this.receiptAccount
        })
        .then((json) => {
      
            if(json.status == 401){
            Cookies.remove('token');
            this.$router.push('/login?type=1');
            }else if(json.status == 200){
            this.success = true
            }
            }).catch((err) => {
                console.error(err);
            });
        },
        receiptTypeCategorise() {
            if(this.receiptType == ['微信']){
                return 'W'
            }else{
                return 'B'
            }
        },
        showAlert() {
            this.alert = !this.alert
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/Account/containers/Credit/EditUser.vue